document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.move-carousel-section').forEach(function (section) {
    var track = section.querySelector('.mc-track');
    var prevBtn = section.querySelector('.mc-arrow--prev');
    var nextBtn = section.querySelector('.mc-arrow--next');

    if (!track) return;

    function scrollAmount() {
      var card = track.querySelector('.mc-card');
      if (!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseInt(style.gap || style.columnGap || 0, 10) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrowState() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrowState);
    });

    window.addEventListener('resize', updateArrowState);
    updateArrowState();
  });
});
